<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
// import Search from "@/components/c-select-search";
// import Browse from "@/components/c-select-browse";
import Loading from "@/components/c-loading";
import InvoiceRow from "@/components/invoice-row";
// import { itemService } from "../../../../services/inventoryservice/item.service";
import { itemtransactionService } from "../../../../services/inventoryservice/itemtransaction.service";
import { itemtransactiondetailService } from "../../../../services/inventoryservice/itemtransactiondetail.service";
// import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Invoice Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
    // Browse,
    // Search,
    InvoiceRow
  },
  watch: {
    valueType: function(newVal) { // watch it
      // console.log(newVal);
      this.loadingStatus(newVal);

      this.valueStatus = newVal == 1 ? 1 : 5;
    }
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Item",
      breadCrumb: {},
      invoiceData: null,
      supplierData: {},
      statusData: {},
      statusDataAll: [],
      typeData: {},
      categoryData: {},
      itemData: {},
      
      valueNumber: '',
      valueDate: this.$moment().clone().format('YYYY-MM-DD'),
      valueSupplier: 0,
      valueStatus: 0,
      valueType: 0,
      valueNotation: '',
      valueRef: '',
      valueTotal: 0,
      valueEntries: [],

      valueItem: 0,
      valueCategory: 0,
      
    };
  },
  mounted() {
    
    this.valueStatus = 1;
    this.valueType = 1;

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } else {
      this.loadingData(0);
    }
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      itemtransactionService.getOne(id)
        .then(response => {
          if(response.data) {
            this.breadCrumb = {
              text: response.data.number,
              active: true,
            };
          }

          // console.log(JSON.stringify(response.data));      

          this.fetchingStats = true;
          this.invoiceData = response;

          this.valueNumber = this.invoiceData.data.number;
          this.valueDate = this.invoiceData.data.transaction_date;
          this.valueSupplier = this.invoiceData.data.supplier_id;
          this.valueStatus = this.invoiceData.data.item_transaction_status_id;
          this.valueType = this.invoiceData.data.type_id;
          this.valueNotation = this.invoiceData.data.notation;
          this.valueRef = this.invoiceData.data.ref;

          this.loadingEntryData(id);

          this.statusDataAll = response.setting.itemtransactionstatuses;
          this.supplierData = {data: response.setting.suppliers};
          this.categoryData = {data: response.setting.categories};
          this.itemData = {data: response.setting.items};
          this.loadingStatus(this.valueType);
          
        });
    },

    loadingEntryData: function(id) {

      itemtransactiondetailService.getListByTransaction(id)
        .then(response => {

          this.valueEntries = response.data;   
               
        });
    },

    loadingStatus: function(typeId) {

      // console.log(JSON.stringify(this.statusDataAll.filter(obj => obj.item_transaction_type_id == typeId)));

      this.statusData = {
        data: this.statusDataAll.filter(obj => obj.item_transaction_type_id == typeId)
      };
    },

    categoryChanged: function(id) {
      console.log(id);
    },

    itemChanged: function(item) {
      console.log(item);

      this.valueEntries.push({
        label: item.label,
        item_id: item.id,
        quantity: 1,
        price: item.price
      });

      this.valueItem = 0;
    },

    formatCurrency(value, sign = '', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },

    getTotal() {
      return this.valueEntries.reduce((sum, val) => sum + (val.price * val.quantity), 0);
    },
    

    submitCancel: function() {

      this.$router.push(this.$route.query.redirectFrom || {
          name: "invoice-list"
      });
      
    },
    submitPrint: function() {

      this.$router.push(this.$route.query.redirectFrom || {
          name: "invoice-list"
      });
      
    },

    clearForm: function() {

      
    }, 

    rowChanged: function(item, index) {
      this.valueEntries[index] = item;
    },

    rowDeleted: function(index) {
      this.valueEntries.splice(index, 1);
    }

  }
};
</script>

<template>
  <Layout>
    <PageHeader :items="[{
      text: $t('invoice.list'),
      href: '/additional/invoice',
    }, this.breadCrumb]" :title="$t('invoice.view')" />

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitPrint" class="row">
    
      <div class="col-lg-8">

        <div class="card">
          <div class="card-body"> 
            
            <div class="row">
              <div class="col-md-5">{{$t('item.text')}}</div>
              <div class="col-md-2">{{$t('invoice.quantity')}}</div>
              <div class="col-md-2 text-end">{{$t('invoice.price')}}</div>
              <div class="col-md-2 text-end">{{$t('invoice.amount')}}</div>
              <div class="col-md-1 text-center"></div>
            </div>
            <div class="row" style="padding-top: 5px; padding-bottom: 10px;"><hr /></div>
            <InvoiceRow v-for="(entry, index) in valueEntries" :key="index"
              @changed="rowChanged"
              @deleted="rowDeleted"
              :disable="true"
              :ref="`entry_${index}`"
              :index="index"
              :item="entry" />
          </div>
        </div>
        <div >
          <div > 
            <div class="row" style="font-size: 14pt;">
              <div class="col-md-9 text-end">{{`${$t('invoice.total')}:`}}</div>
              <div class="col-md-2 text-end">{{formatCurrency(getTotal(), '$')}}</div>
              <div class="col-md-1 text-center"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <Input 
                  :type="'text'"
                  :id="'number'"
                  v-model="valueNumber"
                  :disabled="true"
                  :label="'invoice.number'"
                  :require="true"
                    /> 
              </div>
              <div class="col-md-6">
                <Input 
                  :type="'text'"
                  :id="'ref'"
                  v-model="valueRef"
                  :disabled="true"
                  :label="'invoice.ref'"
                    /> 
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <Select 
                  :id="'supplier_id'"
                  :list="this.supplierData"
                  v-model="valueSupplier"
                  :disabled="true"
                  :label="'supplier.text'"
                  :require="true"
                    /> 
              </div>
              <div class="col-md-6">
                <Input 
                  :type="'date'"
                  :id="'transaction_date'"
                  v-model="valueDate"
                  :disabled="true"
                  :label="'invoice.date'"
                    /> 
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <Select 
                  :id="'item_transaction_status_id'"
                  :list="this.statusData"
                  v-model="valueStatus"
                  :disabled="true"
                  :label="'invoice.status'"
                    /> 
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <b-form-group
                      class="mb-3"
                      :label="$t('invoice.type')"
                      :label-for="id"
                  >
                    <div class="input-group" style="margin-left: 10px;"> 
                      <b-form-group class="input-group" id="type" :disabled="true">
                        <div inline class="row gy-2 gx-3 align-items-end">
                        <b-form-radio
                          v-model="valueType"
                          class="col-sm-auto"
                          value=1
                          plain
                          >{{$t('invoice.in')}}</b-form-radio>
                        <b-form-radio
                          v-model="valueType"
                          class="col-sm-auto"
                          value=2
                          plain
                          >{{$t('invoice.out')}}</b-form-radio>
                        </div>
                      </b-form-group>
                      
                    </div>
                  </b-form-group>
                </div>
                
         
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body"> 
            <div class="row">
              <div class="col-md-6">
                <Button v-bind:icon="'bx bx-x-circle'" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'danger'"
                  @click="submitCancel()"
                  v-bind:title="$t('general.cancel')"  />
              </div>
              <div class="col-md-6">
                <Button v-bind:icon="'bx bx-printer bx-tada'" 
                  v-bind:buttonType="'button'"
                  @click="submitPrint()"
                  v-bind:requesting="tryingToSubmit"
                  v-bind:title="$t('general.print')"  />
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </b-form> 
  
  </Layout>
</template>